import React, { FunctionComponent } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import SortAscIcon from '../../../../components/Icons/SortAscIcon';
import styles from './styles.module.scss';
import Button from '../../../../components/Button';
import { SearchIndexSortBy } from '../../../../services/search/shared';

export type CourseSortBySelectorProps = {
    currentSortByValue: SearchIndexSortBy;
    setSortBy: (newSort: SearchIndexSortBy) => void;
};

export type EducatorSortBySelectorProps = {
    currentSortByValue: SearchIndexSortBy;
    setSortBy: (newSort: SearchIndexSortBy) => void;
};

type Option = {
    value: SearchIndexSortBy;
    label: string;
};

export const EducatorSortBySelector: FunctionComponent<EducatorSortBySelectorProps> = ({
    currentSortByValue,
    setSortBy,
}) => {
    const options: Array<Option> = [
        { value: 'relevance', label: 'Relevance' },
        { value: 'rating_desc', label: 'Rating' },
    ];

    return (
        <SortBySelector
            currentSortByValue={currentSortByValue}
            setSortBy={setSortBy}
            options={options}
        />
    );
};

export const CourseSortBySelector: FunctionComponent<CourseSortBySelectorProps> = ({
    currentSortByValue,
    setSortBy,
}) => {
    const options: Array<Option> = [
        { value: 'relevance', label: 'Relevance' },
        { value: 'rating_desc', label: 'Rating' },
        { value: 'price_desc', label: 'Price - High to Low' },
        { value: 'price_asc', label: 'Price - Low to High' },
    ];

    return (
        <SortBySelector
            currentSortByValue={currentSortByValue}
            setSortBy={setSortBy}
            options={options}
        />
    );
};

export type SortBySelectorProps = {
    currentSortByValue: SearchIndexSortBy;
    setSortBy: (newSort: SearchIndexSortBy) => void;
    options: Array<Option>;
};

const SortBySelector: FunctionComponent<SortBySelectorProps> = ({
    currentSortByValue,
    setSortBy,
    options,
}) => {
    return (
        <div>
            <DropdownMenu.Root>
                <DropdownMenu.Trigger asChild>
                    <Button icon={<SortAscIcon />}>Sort</Button>
                </DropdownMenu.Trigger>
                <DropdownMenu.Portal>
                    <DropdownMenu.Content className={styles.sortBySelectPopOver}>
                        <DropdownMenu.RadioGroup value={currentSortByValue}>
                            {options.map((option) => {
                                return (
                                    <Item
                                        key={option.value}
                                        setSortBy={setSortBy}
                                        value={option.value}
                                        label={option.label}
                                    />
                                );
                            })}
                        </DropdownMenu.RadioGroup>
                    </DropdownMenu.Content>
                </DropdownMenu.Portal>
            </DropdownMenu.Root>
        </div>
    );
};

type ItemProps = {
    value: SearchIndexSortBy;
    label: string;
    setSortBy: (newSort: SearchIndexSortBy) => void;
};

const Item: FunctionComponent<ItemProps> = ({ label, value, setSortBy }) => {
    return (
        <DropdownMenu.RadioItem asChild={true} value={value}>
            <Button onClick={() => setSortBy(value)}>{label}</Button>
        </DropdownMenu.RadioItem>
    );
};

export default SortBySelector;
